var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"nps-card column m-auto"},[_c('div',{staticClass:"box"},[_c('h2',{staticClass:"title has-text-left"},[_vm._v("Share your thoughts")]),_c('nps-box',{attrs:{"in-page":true}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }